import React from 'react';
import bem from '../../../lib/bemUtils/bem';
import { Heading, HeadingHierarchy } from '../Heading/Heading';
import { Modifier } from '../../../lib/bemUtils/Modifier';

export enum ContentBlockHeadlineModifier {
  paddingBottom = 'padding-bottom',
}

type ContentBlockHeadline = {
  title?: string;
  hierarchy?: HeadingHierarchy;
  modifier?: Modifier<ContentBlockHeadlineModifier>;
};

export function ContentBlockHeadline({ title, hierarchy = 2, modifier }: ContentBlockHeadline) {
  if (!title) {
    return null;
  }

  return (
    <Heading hierarchy={hierarchy} className={`${bem('content-block-headline', modifier)} font-bold-24-28`}>
      {title}
    </Heading>
  );
}
